import type { AnimationParticleItem } from '@shared/ui/animations'

export interface GenerateParticlesOptions {
  count: number
  minSize: number
  maxSize: number
}

const randomInRange = (random: () => number, min: number, max: number): number => min + random() * (max - min)

let particleUid = 0

export const generateParticles = ({ count, minSize, maxSize }: GenerateParticlesOptions, random: () => number = Math.random): AnimationParticleItem[] =>
  Array.from({ length: count }, () => ({
    id: particleUid++,
    x: randomInRange(random, 0, 100),
    size: Math.round(randomInRange(random, minSize, maxSize)),
    delay: Math.round(randomInRange(random, 0, 800)),
    duration: Math.round(randomInRange(random, 1800, 2800)),
    rotate: Math.round(randomInRange(random, 360, 720)) * (random() < 0.5 ? -1 : 1),
    drift: Math.round(randomInRange(random, -40, 40)),
  }))
